<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="modalcito">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b>{{obj.xtitle}}</b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">
                <p v-html="obj.xbody">  </p>
                <p> Seleccione el estado de este participante para la plataforma Moodle: <b>{{obj.xusername}}</b> </p>
                <select v-model="estado" class="">
                  <option value="0">Activo</option>
                  <option value="1">Inactivo</option>
                </select>
                <small class="text-primary"> <p>El resultado de la operacion se notifica a: <b> <input type="email" v-model="correo_to"> </b> </p> </small>
            </div> 
            
            <Alertas 
                ref="alertar" 
                v-bind:msgSuccess="'La operacion se realizo satisfactoriamente, revise el correo para ver el resultado.'"
                v-bind:msgLoading="'Aplicando...'"
                />
            <div class="modal-footer">
                <button @click="submit" :disabled="!activo" type="button" class="btn btn-azul">Aceptar</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue'
    export default {
        props: {
            obj:{ // {xid:Number,xtitle:String,xbody:String,xusername:Object,xestado:Number}
                type: Object,
                required: true
            },
        },
        data(){
            return{
                activo: true,
                estado: 0,
                correo_to:'',
            }
        },
        watch:{
            'obj.xid': function(){ 
                if( this.obj.xid == null ) return;
                this.$refs.alertar.reset(); 
                this.activo = true;
                this.estado = this.obj.xestado?0:1;
                window.console.log( "MODALLLLLLLLLLLLLLLLll" ); 
                
                if( !this.obj.sede.correos ){
                  this.activo = false;
                  this.$refs.alertar.invalido("ERROR: la sede no tiene correo."); 
                }else{
                  var cor = this.obj.sede.correos.find( x => x.tipo == 0 );
                  window.console.log( "MODALL ",cor ); 
                  if( cor ) {
                    this.correo_to = cor.direccion;
                  }
                  else{
                    this.activo = false;
                    this.$refs.alertar.invalido("ERROR: la sede no tiene correo del tipo 0 (corporativo)."); 
                  }
                }
            },
            'obj':function(){ 
                this.$refs.alertar.reset();
                this.activo = true;
            }
        },
        components:{Alertas}, 
        methods:{
            hidden(){
                this.$refs.alertar.cargando();
            },
            submit(){
                this.$refs.alertar.cargando(); 
                this.estado = parseInt( this.estado )
                window.console.log( "ZZZZ ",this.obj );
                if( !this.correo_to  ){
                  this.$refs.alertar.invalido("ERROR: la sede no tiene correo corporativo.");
                  return;
                }

                var correo = {
                  "data":{
                    "attendant":{ 
                      "name": "Cambio Estado",
                      "mail": this.correo_to,
                    },
                    "user":{
                      "username": this.obj.xusername,
                      "status": this.estado
                    }
                  }
                }
                var data = JSON.stringify(correo);
                var vue = this;

                // window.console.log( "CORREITO> ",data )
                // window.console.log( "CORREITO> ",correo )

                var config = {
                    method: 'post',
                    url: process.env.VUE_APP_URL_NOTIFIER_ESAM+'change-student-status-notification',
                    headers: { 
                        'Content-Type': 'application/json'
                    },
                    data : data
                };

                window.axios(config)
                    .then(function (res) {
                        // window.console.log('--------------------- RESPUESTA DEL SERVIDOR --------------------------')
                        // const data = res.data
                        window.console.log(res.data)
                        // window.console.log(data)
                        // window.console.log( window.stringifyObject(data) )
                        vue.msg = 'enviado'
                        vue.$refs.alertar.success();
                        vue.$emit('exito');
                    })
                    .catch(function (error) {
                        vue.$refs.alertar.invalido(); 
                        window.console.error(error)
                        vue.msg = error
                });
            }
        },
  mounted(){
    var vue = this;
    window.$('#modalmoodle').on('hidden.bs.modal',function(){
      vue.msg = ''
      //vue.programa = {}
      vue.activo = true;
      vue.$refs.alertar.reset();
    })
  }
    }
</script>